import {createStore,combineReducers, applyMiddleware } from 'redux';
import {thunk} from 'redux-thunk';
import userReducer from './reducers/userReducer';
import { setUser } from './actions/userActions';
import cardReducer from './reducers/cardReducer';

const rootReducer = combineReducers({
  user: userReducer,
  card: cardReducer,

});

const store = createStore(rootReducer, applyMiddleware(thunk));
const token = localStorage.getItem('authToken');
if (token) {
  store.dispatch(setUser(token));
}
export default store;